export const NotFound404 = () => <p>not found</p>
